<template>
  <div>
    <custom-token-form
      v-for="(model, index) in tokenModels"
      :key="index"
      :model="model"
      :empty-value="emptyValue"
      @remove="remove(model)"
    />
    <div class="card-condition__btn-add">
      <ui-button
        class="justify-end"
        icon="fas fa-plus"
        button-style="accent"
        :text="t('Add New Custom Token')"
        @click="add"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import CustomTokenForm from './custom-token-form.vue';
import { useFlowTokenModelsCondition } from './useFlowTokenModelsCondition';

const props = defineProps<{
  conditions: Record<string, Array<{
    values: string[];
    parameter: string;
    predicate: string;
  }>>;
}>();

const emit = defineEmits<{
  close: [];
}>();

const { t, tokenModels, emptyValue, add, remove } = useFlowTokenModelsCondition(
  { conditions: props.conditions, conditionKey: 'customToken' },
  emit,
);
</script>

<style lang="scss"></style>
